import React from 'react';
import { Header, Segment, Container, Grid } from 'semantic-ui-react';
import { ForgotPassword } from '../../_components/users';
import '../../_components/layout/Layout.css';

export const CustomerForgotPassword = () => {
  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <div
              style={{
                marginBottom: '0px',
                minHeight: '660px',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingBottom: '0px'
              }}
            >
              <Segment>
                <Grid columns={1}>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <Header as="h2">FORGOT PASSWORD</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <ForgotPassword />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
